import React,{ useEffect, useState,useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import  UserContext from "../components/appContext";
import { useTranslation } from "react-i18next";
import axios from "axios";

const MyTournaments = () => {
    let [myTournaments, setMyTournaments] = useState();
    const { userId, userToken,urlToken, databaseURL } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    let [page, setPage] = useState(1);
    let [pageCount, setPageCount] = useState(20);
    const [finalPage, setFinalPage] = useState(1);
    const [gettingData,setGettingData] = useState(false);
    const { t } = useTranslation();

    const fetchMyTournaments = async (newPage) =>{
        if(gettingData === false){
            setGettingData(true);
            setPage(newPage);
            //setLoading(true);
            return await axios
                .get(`${databaseURL}/api/lobby/mytournaments/${userId}?page=${newPage}&pageSize=${pageCount}`)
                .then((response) => {
                    if(response && response.data && response.data.myTournaments){
                        setMyTournaments(response.data.myTournaments); 
                    }
                    //setLoading(false);
                    setGettingData(false);
                    setFinalPage(response.data.finalPage === 1 ? 1 : 0);
                })
                .catch((error) => {
                    setGettingData(false);
                    console.log(error);
                })
        }
    }

    useEffect(() =>{
        fetchMyTournaments(1);
    },[])

    const moveToNextTournamentsPage = () => {
        let newPage = page+1
        fetchMyTournaments(newPage);

    }

    const backToPreviousTournamentsPage = () => {
        let newPage = page-1;
        if(newPage > 0){
            
            fetchMyTournaments(newPage);
        }
    }

    return (
        <div className="container-page">
            <div className="content-page">
                <div className="row gx-1 mb-1">
                    <div className="col-8">
                        <h5 className = "mytournamentsHeader">{t("MY_TOURNAMENTS") }</h5>
                    </div>
                    <div className="col-4 text-end">
                        <Link to={'/archiveMyTournaments'+urlToken} className="text-link">{t("ARCHIVE")}</Link>
                    </div>
                </div>
                <div className="card-table">
                    <div className="row gx-1 ">
                        <div className="col-3 table-col">
                            <div className="p-1 title text-start">{t("NAME") }</div>
                        </div>
                        <div className="col-3 table-col">
                            <div className="p-1 title">{t("POSITION")}</div>
                        </div>
                        <div className="col-3 table-col">
                            <div className="p-1 title">{t("PRIZE")}</div>
                        </div>
                        <div className="col-3 table-col">
                            <div className="p-1 title">{t("BATTLES")}</div>
                        </div>
                    </div>
                    {page === 1 ?
                    <div className="mb-1" style={{paddingTop:"4px", paddingBottom:"4px"}}>
                        {/* <img style={{opacity: 0.1}} alt="caretdown" src={require("../../assets/sky/images/caretup.png")} />*/}
                            <img style={{opacity: 0.2}} className={`card-arrow down`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />
                        </div> 
                    :
                        <div className="mb-1" style={{paddingTop:"4px", paddingBottom:"4px"}} onClick={()=>backToPreviousTournamentsPage()}>
                            {/*<img style={{opacity: 1}}  alt="caretdown" src={require("../../assets/sky/images/caretup.png")} />*/}
                            <img style={{opacity: 1}} className={`card-arrow down`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />
                        </div> 
                    }
                    {myTournaments && myTournaments.map((data,index) => (
                        <div key={index} className="row gx-1 table-row ">
                            <div className="col-3 table-col">
                                <div className="p-1 text-start">{data.name}</div>
                            </div>
                            {data.mode && data.mode === 3 ?
                                <div className="col-6 table-col">
                                    <div className="p-1">Sit & Spin - View Battles </div>
                                </div>
                            :
                            <>
                            <div className="col-3 table-col">
                                <div className="p-1">{data.yourPosition === 0 ? "-" : data.yourPosition}</div> 
                            </div>
                            <div className="col-3 table-col">
                                <>
                                {data.prize && data.prize.indexOf(" CASH_CONVERT") > -1 ?
                                    <div className="p-1">{new Intl.NumberFormat(t("language_code"), { 
                                        style: 'currency',
                                        currency: t("currency_code")
                                    }).format(data.prize.slice(0, data.prize.indexOf(" CASH_CONVERT"))/100)}</div>
                                :   
                                    <div className="p-1">{data.prize}</div>
                                }  
                                </> 
                            </div>
                            </>
                            }
                            <div className="col-3 table-col">
                                <div className="p-1">
                                    <Link to={'/mybattles/'+data.id+urlToken} className="page-button">{t("VIEW")}</Link>
                                </div>
                            </div>
                        </div>
                        ))
                    }
                    <div className="mt-2 d-flex justify-content-center align-items-center">
                    {finalPage === 1 ? 
                        <div style={{width:"100%", textAlign:"center"}}>
                            <img style={{opacity: 0.2}} className={`card-arrow`}  alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />    
                        </div>
                    :
                        <div style={{width:"100%", textAlign:"center"}} onClick={()=>moveToNextTournamentsPage()}>
                            <img style={{opacity: 1}} className={`card-arrow`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />    
                        </div>
                    }       
                </div>
                    </div>
            </div>
    </div>
    );
};
  
export default MyTournaments;